import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BankingService } from '../../../features/banking/services/banking.service';

@Component({
  selector: 'upload-banking-dialog',
  templateUrl: './upload-banking-dialog.html',
  styleUrls: ['./upload-banking-dialog.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatOptionModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class UploadBankingDialog {
  importStatementForm: FormGroup;
  file: File | null = null;
  accounts: any;
  search: string;

  constructor(
    private bankingService: BankingService,
    private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<UploadBankingDialog>,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: { bankId: number }
  ) {}

  ngOnInit() {
    this.importStatementForm = this.fb.group({
      file: [null, Validators.required],
    });

    document.addEventListener('dragover', this.preventDefaultBehavior);
    document.addEventListener('drop', this.preventDefaultBehavior);
  }

  preventDefaultBehavior(event: DragEvent) {
    event.preventDefault();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();

    if (event.dataTransfer?.files.length) {
      this.onFileSelected({ target: { files: event.dataTransfer.files } });
    }
  }

  onFileSelected(event: any): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      console.log('Selected file:', file);

      const allowedTypes = ['text/csv'];
      if (allowedTypes.includes(file.type)) {
        this.file = file;
        this.importStatementForm.patchValue({ file: file });
        this.importStatementForm.get('file')!.updateValueAndValidity();
      } else {
        this.file = null;
        this.toastr.error('Only CSV files are allowed');
      }
    }
  }

  removeFile(): void {
    this.file = null;
    const input = document.querySelector(
      'input[type="file"]'
    ) as HTMLInputElement;
    if (input) {
      input.value = '';
    }
  }

  onUpload() {
    if (this.importStatementForm.invalid || !this.file) {
      this.importStatementForm.markAllAsTouched();
      this.toastr.error('Please select a valid CSV file');
      return;
    }

    const accountId = Number(this.data.bankId);

    this.bankingService.bulkCreateTransactions(this.file, accountId).subscribe({
      next: (response) => {
        console.log(response);

        if (response && !response.errors) {
          this.toastr.success('Transactions uploaded successfully!', 'Success');
          this.dialogRef.close({
            file: this.file,
            offsetAccountId: accountId,
          });
        } else if (response?.errors) {
          this.toastr.error(response?.errors[0]?.message, 'Error');
        }
      },
      error: (error) => {
        this.toastr.error(error, 'Bulk transaction creation failed');
        this.dialogRef.close();
      },
    });
  }
}
